export default class EventRegistration {
    public FirstName = '';
    public LastName = '';
    public Email = '';
    public EventId = 0;
    public Guid = '';
    public Status = '';
    public CreatedAt: Date = new Date(Date.now());
    public CreatedBy = '';
    public UpdatedAt?: Date;
    public UpdatedBy?: Date;
    public TicketTypeId = 0;
    public Cancelled = false;
    public SpecialCode = '';
    public RecommendedBy = '';
    public Price = 0;
    public Paid = 0;
    public PaymentLink = '';
    public Country = '';
    public Zip = '';
    public City = '';
    public MobileNumber = '';
    public SexTypeId?: number = 0;
    public DanceRoleId?: number = 0;
    public AdvanceLevelId?: number = 0;
    public SourceOfInformation = '';
    public AccommodationTypeId?: number = 0;
    public Id = 0;
}
